//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoginLayout from '../../layouts/LoginLayout';
import InputText from '../inputs/InputText';
import ApiHelper from '../../helpers/ApiHelper';
import UserService from '../../services/UserService';
import { KeyIcon } from 'vue-feather-icons';

export default {
	name: 'RecoveryPasswordForm',
	components: { InputText, LoginLayout, KeyIcon },
	data() {
		return {
			userService: new UserService(this.$axios),
			apiHelper: new ApiHelper(),
			email: null,
		};
	},
	methods: {
		async recover() {
			this.userService
				.passwordRecovery(this.email)
				.then((res) => {
					if (res.status === 200) {
						this.$store.commit('setAlert', {
							show: true,
							message: 'Te hemos enviado un correo para reestablecer tu contraseña',
							type: 'success',
						});
					}
				})
				.catch((error) => {
					this.apiHelper.handleErrors(error, this.$refs.obs, this.$store);
				});
		},
	},
};
